import { ShipmentModel } from "features/shared/shipmentCard.types";
import { usePanelViews } from "features/shared/usePanelViews.hook";
import { appStore } from "entities/App";
import { authStore } from "entities/Auth";
import { roadCardDeleteModalStore } from "entities/RoadCardDeleteModal";
import { isRoadSearchShipmentModel, RoadSearchCardModel, roadSearchCardStore } from "entities/RoadSearchCard";
import { voidFunc } from "shared/lib/common.lib";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";
import { Nullable } from "shared/lib/typeCheck.lib";

type ShipmentCardModel = RoadSearchCardModel;

// type FollowFunc = (card: RailSearchCardModel) => void;
type AskDeletingCardFunc = (card: ShipmentCardModel) => void;
type DeleteCardHandler = (card: ShipmentCardModel) => void;
type CancelDeletingSavedCardFunc = () => void;
type DeleteCardModalHandlerFunc = () => void;
type UseRoadCardActionsReturnType = {
  deleteRoadCardHandler: DeleteCardHandler;
  deleteRoadCardModalHandler: DeleteCardModalHandlerFunc;
  cancelRoadCardDeleting: CancelDeletingSavedCardFunc;
  //   roadCardFollow: FollowFunc;
  //   isRoadCardFollowLoading: boolean;
  //   isRoadCardFollowButtonVisible: boolean;
  isRoadCardDeleting: boolean;
};

type UseRoadCardActionsParams = {
  cardToDelete?: Nullable<ShipmentModel>;
  setCardToDeleteAction?: (card: ShipmentModel) => {
    type: string;
    payload: ShipmentModel | null;
  };
  resetCardToDeleteAction?: () => {
    type: string;
  };
  //   removeFilteredCardAction: (
  //     cards: SeaSavedCardModel | AirSavedCardModel | RoadSearchCardModel
  //   ) => PayloadAction<SeaSavedCardModel | AirSavedCardModel | RailSearchCardModel>;
  //   removeCardByTagAction: (
  //     cards: SeaSavedCardModel | AirSavedCardModel | RoadSearchCardModel
  //   ) => PayloadAction<SeaSavedCardModel | AirSavedCardModel | RailSearchCardModel>;
  //   refreshTags: () => void;
};
export const useRoadCardActions = ({
  cardToDelete,
  setCardToDeleteAction,
  resetCardToDeleteAction,
  //   removeFilteredCardAction,
  //   removeCardByTagAction,
  //   refreshTags,
}: UseRoadCardActionsParams): UseRoadCardActionsReturnType => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);
  const requestedFromUrl = useAppSelector(appStore.selectors.requestedFromUrl);
  //   const savedCards = useAppSelector(railSavedCardStore.selectors.savedCards);
  const searchCards = useAppSelector(roadSearchCardStore.selectors.searchCards);
  const { showPreviousView, isCurrentViewOpenedCard } = usePanelViews();

  //   const removeSavedCardFromUI = (card: RoadSearchCardModel) => {
  // dispatch(roadSavedCardStore.actions.removeSavedCardAction(card));
  // dispatch(removeFilteredCardAction(card));
  // dispatch(removeCardByTagAction(card));
  //   };

  const resetDeleteModal = () => {
    dispatch(roadCardDeleteModalStore.actions.closeDeleteModalAction());
    if (resetCardToDeleteAction) {
      dispatch(resetCardToDeleteAction());
    }
  };

  const handleModalDeleting = () => {
    resetDeleteModal();
    if (isAuthenticated) {
      //   refreshTags();
    }
    if (isCurrentViewOpenedCard) {
      showPreviousView();
    }
  };

  const askDeletingCard: AskDeletingCardFunc = (card) => {
    dispatch(roadCardDeleteModalStore.actions.openDeleteCardModalAction());
    if (setCardToDeleteAction) {
      dispatch(setCardToDeleteAction(card));
    }
  };

  const createRoadCardDeleteHandlers = (): {
    deleteRoadCardHandler: DeleteCardHandler;
    deleteRoadCardModalHandler: DeleteCardModalHandlerFunc;
  } => {
    // case 1: opened from url (and clicked delete button)
    if (isCurrentViewOpenedCard && requestedFromUrl) {
      return {
        deleteRoadCardHandler: (card) => {
          askDeletingCard(card);
        },
        deleteRoadCardModalHandler: () => {
          if (!cardToDelete) {
            handleModalDeleting();
            return;
          }

          if (!isAuthenticated && isRoadSearchShipmentModel(cardToDelete)) {
            dispatch(roadSearchCardStore.actions.removeSearchCardAction(cardToDelete));
            handleModalDeleting();
            return;
          }

          if (isAuthenticated && isRoadSearchShipmentModel(cardToDelete) && cardToDelete.reference) {
            // const existingSavedCard = savedCards.find((c) => c.reference === cardToDelete.reference);

            // if (existingSavedCard) {
            //   deleteSavedCardRequest(existingSavedCard.id, {
            //     onSettled: () => {
            //       removeSavedCardFromUI(existingSavedCard);
            //       handleModalDeleting();
            //     },
            //   });
            //   return;
            // }

            const existingSearchCard = searchCards.find((c) => c.reference === cardToDelete.reference);

            if (existingSearchCard) {
              dispatch(roadSearchCardStore.actions.removeSearchCardAction(cardToDelete));
              handleModalDeleting();
            }

            // getCards(
            //   { limit: 1, where: { reference: cardToDelete.reference } },
            //   {
            //     onSettled: (response) => {
            //       if (response?.length) {
            //         deleteSavedCardRequest(response[0].id, {
            //           onSettled: () => {
            //             removeCardsCache();
            //             handleModalDeleting();
            //           },
            //         });
            //       }
            //     },
            //   }
            // );
            return;
          }

          //   if (isRailSavedShipmentModel(cardToDelete)) {
          //     removeSavedCardFromUI(cardToDelete);
          //     deleteSavedCardRequest(cardToDelete.id, {
          //       onSettled: () => handleModalDeleting(),
          //     });
          //   }
        },
      };
    }

    // case 2: clicked delete button on openned card or closed card
    if (!requestedFromUrl) {
      return {
        deleteRoadCardHandler: (card) => {
          askDeletingCard(card);
        },
        deleteRoadCardModalHandler: () => {
          //   if (isRailSearchShipmentModel(cardToDelete)) {
          //     deleteSavedCardRequest(cardToDelete.id, {
          //       onSettled: () => {
          //         removeSavedCardFromUI(cardToDelete);
          //         handleModalDeleting();
          //       },
          //     });
          //     return;
          //   }
          if (isRoadSearchShipmentModel(cardToDelete)) {
            dispatch(roadSearchCardStore.actions.removeSearchCardAction(cardToDelete));
            handleModalDeleting();
            return;
          }
        },
      };
    }

    return {
      deleteRoadCardHandler: voidFunc,
      deleteRoadCardModalHandler: voidFunc,
    };
  };

  //   const follow: FollowFunc = (data) => {
  //     if (!data || !data?.reference) return;
  //     const { atd, etd, ata, eta, predictiveETA } = data;
  //     const { departureDate, arrivalDate } = resolveDateValues({ atd, etd, ata, eta, predictiveETA });
  //     const departureDateWithLocale = departureDate.value ? formatFollowCardDate(departureDate.value) : null;
  //     const arrivalDateWithLocale = arrivalDate.value ? formatFollowCardDate(arrivalDate.value) : null;

  //     followCard(
  //       {
  //         reference: data.reference,
  //         location: {
  //           pin: data.currentPin,
  //           from: data.fromDirection ?? null,
  //           to: data.toDirection ?? null,
  //           // TODO: replace with API data
  //           transport: SeaRouteTypesModel.SEA,
  //         },
  //         type: data.referenceType,
  //         equipments_count: data.containersAmount,
  //         carrier_scac: data.getCarrierScac(),
  //         carrier_name: data.carrierName ?? null,
  //         status: data.status ?? ShipmentStatusesModel.UNKNOWN,
  //         size_type: JSON.stringify(data.containersSizeTypes),
  //         date: {
  //           from_actual: departureDate.isActual,
  //           from: departureDateWithLocale,
  //           to_actual: arrivalDate.isActual,
  //           to: arrivalDate.isPredictive ? null : arrivalDateWithLocale,
  //           to_predictive: arrivalDate.isPredictive ? arrivalDate.value : null,
  //         },
  //         updated_at: formatApiDate(new Date()),
  //       },
  //       {
  //         onSuccess: (response) => {
  //           dispatch(seaSearchCardStore.actions.removeSearchCardAction(data));
  //           dispatch(seaSavedCardStore.actions.prependSavedCardAction({ data: response }));
  //         },
  //       }
  //     );
  //   };

  const cancelRoadCardDeleting: CancelDeletingSavedCardFunc = () => {
    // if (isSavedCardDeleting) return;
    resetDeleteModal();
  };

  return {
    ...createRoadCardDeleteHandlers(),
    cancelRoadCardDeleting,
    // TODO: replace with real value
    isRoadCardDeleting: false,
    // railCardFollow: follow,
    // isRoadCardFollowLoading: isCardFollowLoading,
    // isRoadCardFollowButtonVisible: typeof followedCard === "undefined" && isAuthenticated,
    // isRoadCardDeleting: isSavedCardDeleting,
  };
};
